import { z } from "zod";
import { supplyPointSchema } from "@/types/schemas/supplyPoints";
import { templateSchema } from "@/types/schemas/templates";
import { executivePersonSchema } from "./person";

export const generatedContractRequestSchema = z
  .object({
    id: z.number(),
    sessionKey: z.string(),
    attachments: z.object({
      contractRequest: z.nullable(z.string()),
      contractDraft: z.string(),
    }),
    templates: z.nullable(z.array(templateSchema)).default([]),
    executivePeople: z.array(executivePersonSchema),
    supplyPoints: z.array(supplyPointSchema),
    customerId: z.string().nullable(),
    crmObjectId: z.string().nullable(),
  })
  .transform(contract => {
    const { supplyPoints, ...rest } = contract;
    return {
      ...rest,
      supplyPoint: contract.supplyPoints[0]!,
    };
  });

export type GeneratedContractRequest = z.infer<typeof generatedContractRequestSchema>;
